<template>
    <v-menu bottom right>
        <template #activator="{on}">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon large>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                data-sentry-label="Przekieruj na listę z papierami"
                @click="redirectToList('configurationsMaterialsPapers')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Papiery</v-list-item-title>
            </v-list-item>
            <v-list-item
                data-sentry-label="Przekieruj na listę z grupami papierów"
                @click="redirectToList('configurationsMaterialsPaperGroups')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Grupy Papierów</v-list-item-title>
            </v-list-item>
            <v-list-item
                data-sentry-label="Przekieruj na listę z innymi materiałami"
                @click="redirectToList('configurationsMaterialsOtherMaterials' )"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Inne materiały</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import router from '@/router'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SelectMenu',
    methods: {
        redirectToList(route) {
            if (route !== router.currentRoute.name) {
                router.push({ name: route })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
    }
}
</script>
